var _react_refresh_temp_1, _react_refresh_temp_2;
var _react_refresh_temp_3;
_react_refresh_temp_3 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { LocalParticipant, Track } from 'livekit-client';
import { createSelector } from '@reduxjs/toolkit';
import { concat, isEmpty } from 'lodash';
import { useAppSelector } from '../../../store';
import { participantsSelector } from '../../../store/slices/participantSlice';
import VideosComponentElms from './videosComponentElms';
import VideoParticipant from './videoParticipant';
import { CurrentConnectionEvents, } from '../../../helpers/livekit/types';
const refreshWebcamsSelector = createSelector(_react_refresh_temp_1 = (state) => state.roomSettings, (roomSettings) => roomSettings.refreshWebcams);
$RefreshReg$(_react_refresh_temp_1, "refreshWebcamsSelector$createSelector");
const VideosComponent = ({ currentConnection, isVertical, }) => {
    _react_refresh_temp_3();
    const participants = useAppSelector(participantsSelector.selectAll);
    const refreshWebcams = useAppSelector(refreshWebcamsSelector);
    const [videoSubscribers, setVideoSubscribers] = useState();
    const [allParticipants, setAllParticipants] = useState([]);
    const [totalNumWebcams, setTotalNumWebcams] = useState(0);
    useEffect(() => {
        if (currentConnection.videoSubscribersMap.size) {
            setVideoSubscribers(currentConnection.videoSubscribersMap);
        }
        currentConnection.on(CurrentConnectionEvents.VideoSubscribers, setVideoSubscribers);
        return () => {
            currentConnection.off(CurrentConnectionEvents.VideoSubscribers, setVideoSubscribers);
        };
    }, [currentConnection]);
    useEffect(() => {
        if (!videoSubscribers) {
            return;
        }
        let totalNumWebcams = 0;
        const localSubscribers = [];
        const adminPinSubscribers = [];
        const adminSubscribers = [];
        const otherPinSubscribers = [];
        const otherSubscribers = [];
        videoSubscribers.forEach((participant) => {
            // we will only take if source from Camera
            const videoTracks = participant
                .getTracks()
                .filter((track) => track.source === Track.Source.Camera);
            if (videoTracks.length) {
                let isAdmin = false;
                const pinWebcam = participants.find((p) => p.userId === participant.identity && p.pinWebcam);
                if (participant.metadata && !isEmpty(participant.metadata)) {
                    const metadata = JSON.parse(participant.metadata);
                    isAdmin = metadata.is_admin;
                }
                const participantType = {
                    isAdmin,
                    isLocal: participant instanceof LocalParticipant,
                };
                //for (let i = 0; i < 20; i++) {
                totalNumWebcams += videoTracks.length;
                const elm = (_jsx(VideoParticipant, { 
                    //key={participant.sid + '_' + i}
                    participantType: participantType, participant: participant }, participant.sid));
                if (isAdmin && pinWebcam) {
                    adminPinSubscribers.push(elm);
                }
                else if (isAdmin) {
                    adminSubscribers.push(elm);
                }
                else if (pinWebcam) {
                    otherPinSubscribers.push(elm);
                }
                else if (participant instanceof LocalParticipant) {
                    localSubscribers.push(elm);
                }
                else {
                    otherSubscribers.push(elm);
                }
            }
        });
        const allParticipants = concat(adminPinSubscribers, adminSubscribers, otherPinSubscribers, localSubscribers, otherSubscribers);
        setAllParticipants(allParticipants);
        setTotalNumWebcams(totalNumWebcams);
    }, [videoSubscribers, refreshWebcams]);
    return (_jsx(VideosComponentElms, { allParticipants: allParticipants, totalNumWebcams: totalNumWebcams, isVertical: isVertical }));
};
_react_refresh_temp_2 = VideosComponent;
$RefreshReg$(_react_refresh_temp_2, "VideosComponent");
_react_refresh_temp_3(VideosComponent, "zmPu5MTOQJEAX9EfLSgKM+d/e7I=", false, () => [useAppSelector, useAppSelector]);
export default VideosComponent;
